<div class="package-table__wrapper">
  <table class="lum-table lum-table--classic striped">
    <tr class="table__head-row">
      <th>ID</th>
      <th>Name</th>
      <th></th>
    </tr>
    <tbody>
      <tr *ngFor="let row of data; trackBy: trackById; let i = index">
        <td>{{ row.id }}</td>
        <td>{{ row.name }}</td>
        <td class="text-right">
          <a
            class="mr-2 text-danger cursor-pointer"
            href="javascript:;"
            (click)="deleteEvent.emit(row.id)"
          >
            <i class="fas fa-trash"></i>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>
